

import {Component, Vue} from "vue-property-decorator";
import {AuthRequest, ResetPasswordRequest} from "shared/api/routes/auth";
import {Api} from "shared/api";
import {AuthService} from "@/services/auth";
import {apiHandler} from "@/services/api-handler";

@Component({})
export default class PasswordReset extends Vue {
    authorization: ResetPasswordRequest = {token: "", password: ""};
    confirmPassword = "";

    async mounted() {
        if (AuthService.user) {
            await this.$router.push("/");
            return;
        }
        if (!this.$route.query.hasOwnProperty("token")) {
            await this.$router.push("/");
            return;
        }
        this.authorization.token = this.$route.query.token as string;
        const validTokenCheck = await apiHandler(() => Api.auth.reset.Get({token: this.authorization.token}));
        if (!validTokenCheck.valid) {
            alert("Token is not valid.");
            await this.$router.push("/");
        }
    }

    async sendReset(event: Event) {
        event.preventDefault();
        if (this.confirmPassword !== this.authorization.password) {
            alert("Passwords do not match");
            return;
        }
        await apiHandler(() => Api.auth.reset.Patch(this.authorization));
        alert("You password has been reset.");
        await this.$router.push("/");
    }
}

